var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveAndAcceptIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_4119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00066 9.33335C7.645 9.33335 8.16734 8.81101 8.16734 8.16668C8.16734 7.52234 7.645 7 7.00066 7C6.35632 7 5.83398 7.52234 5.83398 8.16668C5.83398 8.81101 6.35632 9.33335 7.00066 9.33335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.146 2.4045L11.5955 0.854C11.4404 0.701285 11.2686 0.566481 11.0833 0.452074V1.75C11.0814 3.36003 9.77668 4.66473 8.16665 4.66668H5.83332C4.2233 4.66473 2.91859 3.36003 2.91668 1.75V0C1.30665 0.00194141 0.00194141 1.30665 0 2.91668V11.0834C0.00194141 12.6934 1.30665 13.9981 2.91668 14H11.0834C12.6934 13.9981 13.9981 12.6934 14 11.0834V4.4666C14.0022 3.69275 13.6947 2.9502 13.146 2.4045ZM7 10.5C5.71134 10.5 4.66668 9.45533 4.66668 8.16668C4.66668 6.87802 5.71134 5.83335 7 5.83335C8.28866 5.83335 9.33332 6.87802 9.33332 8.16668C9.33332 9.45533 8.28866 10.5 7 10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 3.49997H8.16731C9.1338 3.49997 9.91731 2.71646 9.91731 1.74997V0.0373242C9.79049 0.0166523 9.66247 0.00418359 9.53406 0H4.08398V1.75C4.08398 2.71646 4.86749 3.49997 5.83398 3.49997Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_4119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAndAcceptIcon);
export default __webpack_public_path__ + "static/media/SaveAndAcceptIcon.d5810f9b329468c2ef2b7d4047386629.svg";
export { ForwardRef as ReactComponent };